import { PushNotificationsService } from "@app/core/notifications/domain/push-notifications.service";
import { Observable, fromEventPattern, map, throwError } from "rxjs";
import { Injectable } from "@angular/core";
import { environment } from "../../../../../environments/environment";
import {
  DeviceDAO,
  PushNotificationsService as App2uPushNotificationsService,
} from "@app2u/notifications";
import { SendPushPlayerIdWS } from "@app/core/notifications/data/network/send-push-player-id.ws.service";
import { TokenRepo } from "@app/core/shared/domain/token.repo";
import { MissingCredentialsError } from "@app/core/shared/domain/missing-credentials.error";
import { PushNotifications } from "@capacitor/push-notifications";
import OneSignal from "onesignal-cordova-plugin";
import { OpenedEvent } from "onesignal-cordova-plugin/dist/models/NotificationOpened";
import { OneSignalPushNotificationMapper } from "@app/core/notifications/data/network/one-signal-push-notification.mapper";
import { NotificationOpenedResult } from "@app/core/notifications/domain/notification-open-result";

@Injectable({
  providedIn: "root",
})
export class PushNotificationsDeviceWS {
  constructor(
    private sendPushPlayerIdWS: SendPushPlayerIdWS,
    private tokenRepo: TokenRepo
  ) {}
  execute(deviceId: string): any {
    const token = this.tokenRepo.get();
    if (token == null) {
      console.error("Token is null");
      return throwError(() => new MissingCredentialsError());
    }
    return this.sendPushPlayerIdWS.execute(deviceId, token);
  }
}

@Injectable()
export class LibraryPushNotificationsService
  implements PushNotificationsService
{
  constructor(
    private app2uPushNotificationsService: App2uPushNotificationsService,
    private pushNotificationsDeviceWS: PushNotificationsDeviceWS,
    private deviceDAO: DeviceDAO
  ) {}

  get onNotificationOpen$(): Observable<NotificationOpenedResult> {
    return fromEventPattern<OpenedEvent>((handler) => {
      OneSignal.setNotificationOpenedHandler(handler);
    }).pipe(map((value) => OneSignalPushNotificationMapper.deserialize(value)));
  }

  get onSubscriptionChange$(): Observable<string | undefined> {
    return this.app2uPushNotificationsService.onSubscriptionChange$ as any;
  }

  get onNotificationReceived$(): Observable<void> {
    return fromEventPattern<void>((handler) =>
      PushNotifications.addListener("pushNotificationReceived", () => handler())
    );
  }

  init(): void {
    this.app2uPushNotificationsService.init(
      environment.ONE_SIGNAL_ID,
      this.deviceDAO,
      this.pushNotificationsDeviceWS
    );
  }

  requestPermissions(): Observable<boolean> {
    return this.app2uPushNotificationsService.requestPermissions() as any;
  }

  enableNotifications(): void {
    this.app2uPushNotificationsService.enableNotifications();
  }
}
